<template lang="pug">
validation-observer(ref='validation' tag='div')
  div(v-if="radios.length > 0")
    div.flex.margin-top
      div
        validation-provider(rules="required", v-slot="{ errors }")
          el-radio-group.radio-group(
            name="radios",
            v-model="valRadioInicial",
            @input="changeRadio"
          )
            .container
              div.flex-buttons.input(:class="{'erro' : errors.length}")
                el-radio.margin(
                  :border="true",
                  v-for="r in isDecisao ? radiosParecer : radiosDespacho",
                  :label='r.valor',
                  :key='r.valor'
                ) {{ r.nome }}
              span.help.erro {{ errors[0] }}
        div(v-if="showSelecionaUsuario && isDespacho")
          validation-provider(rules="required", v-slot="{ errors }")
            el-card.card(shadow="hover").container-select
              p Selecione o {{ perfil }} :
              el-select.full-width.input(
                :class="{'erro' : errors.length}",
                v-model='changeUsuario',
                placeholder='Selecione o responsável',
                no-match-text="Usuário não encontrado",
                no-data-text="Nenhum usuário disponível",
                filterable,
                clearable,
              )
                el-option(
                  v-for='usuario in usuariosDisponiveis',
                  :key='usuario.id',
                  :label='usuario.pessoa.pessoaFisica.nome',
                  :value='usuario.id'
                )
              span.help.erro {{ errors[0] }}
</template>
<script>
import axios from '@/utils/api'
import { mapActions } from 'vuex'
const regrasAnalise = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default
const { radiosDJ, optionsRadios, showSelecionaUsuarioDj, perfilNotToShowSelecionaUsuario, findUsersDj, showSelecionaUsuario, findUsersDRV, findUsersConsultoresJuridicos } = regrasAnalise.cadastro
export default {

  props: {
    radios: {
      type: Array,
      required: true
    },
    isDecisao: {
      type: Boolean,
      required: true
    },
    radioInicial: {
      type: String,
      required: false,
      default: null
    },
    portariaComNumero: {
      type: Boolean,
      default: false
    },
    isEsconderRetorno: {
      type: Boolean,
      required: false,
      default: false
    },
    isEsconderEncaminhamento: {
      type: Boolean,
      required: false,
      default: false
    },
    processo: {
      type: Object,
      required: false
    },
    isEsconderIndeferir: {
      type: Boolean,
      required: false,
      default: false
    },
    isModuloMoverProcesso: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  data () {
    return {
      radiosDespacho: [],
      radiosParecer: [],
      perfil: null,
      usuarioLogado: null,
      usuarioVinculado: null,
      acaoSelecionada: null,
      advogados: [],
      procuradores: [],
      vistoriadores: [],
      consultoresJuridicos: [],
      assessores: [],
      usuariosDisponiveis: [],
      isDespacho: true,
      valRadioInicial: this.radioInicial
    }
  },

  async mounted () {
    this.usuarioLogado = await this.getUsuario()
    if (this.usuarioLogado.perfilSelecionado || this.isModuloMoverProcesso) {
      this.montarRadios(this.usuarioLogado?.perfilSelecionado?.codigo)
    }
  },

  computed: {
    showSelecionaUsuario () {
      return (showSelecionaUsuarioDj.includes(this.valRadioInicial) ||
        (showSelecionaUsuario && showSelecionaUsuario.includes(this.valRadioInicial) && (!perfilNotToShowSelecionaUsuario ||
        (this.usuarioLogado && this.usuarioLogado.perfilSelecionado && !perfilNotToShowSelecionaUsuario.includes(this.usuarioLogado.perfilSelecionado.codigo)))))
    },
    changeUsuario: {
      get () {
        return this.usuarioVinculado
      },
      set (value) {
        this.usuarioVinculado = value
        this.emitir()
      }
    }
  },

  watch: {
    'isDecisao': {
      async handler (val, oldval) {
        if (val !== oldval) {
          this.usuarioVinculado = null
          this.isDespacho = !val
          this.valRadioInicial = null
        }
      }
    }
  },

  methods: {
    ...mapActions({
      getUsuario: 'auth/getUsuario'
    }),

    changeRadio (val) {
      this.valRadioInicial = val
      this.montarSelectUsuarios()
      this.usuarioVinculado = null
      this.emitir()
    },

    async montarSelectUsuarios () {
      switch (this.valRadioInicial) {
        case 'AGUARDANDO_ANALISE.ADVOGADO.DJ':
          this.usuariosDisponiveis = this.advogados
          this.perfil = 'Advogado'
          break
        case 'AGUARDANDO_ANALISE.ASSESSOR.DJ':
          this.usuariosDisponiveis = this.assessores
          this.perfil = 'Assessor'
          break
        case 'AGUARDANDO_ANALISE.PROCURADOR.DJ':
          this.usuariosDisponiveis = this.procuradores
          this.perfil = 'Procurador'
          break
        case 'FINALIZAR.DSF':
          await this.buscarVistoriadores()
          this.usuariosDisponiveis = this.vistoriadores
          this.perfil = 'Vistoriador'
          break
        case 'FINALIZAR.DIPRE':
          await this.buscarConsultoresJuridicos()
          this.usuariosDisponiveis = this.consultoresJuridicos
          this.perfil = 'Consultor Jurídico'
          break
      }
    },

    emitir () {
      const obj = {
        acao: this.valRadioInicial,
        usuario: this.usuarioVinculado
      }
      this.$emit('changeRadio', obj)
    },

    async getByPerfil (perfil) {
      const data = await axios({
        method: 'post',
        url: 'usuarios/getByPerfil',
        data: [].concat(perfil)
      })
      return data
    },

    async buscarUsuariosJuridico () {
      const {advogados, assessores, procuradores} = await findUsersDj(this.getByPerfil)
      this.advogados = advogados
      this.assessores = assessores
      this.procuradores = procuradores
    },

    async buscarVistoriadores () {
      const { vistoriadores } = await findUsersDRV(this.getByPerfil)
      this.vistoriadores = vistoriadores
    },

    async buscarConsultoresJuridicos () {
      const { consultoresJuridicos } = await findUsersConsultoresJuridicos(this.getByPerfil)
      this.consultoresJuridicos = consultoresJuridicos
    },

    filterActionByOptionRadio (radios, radiosPerfil) {
      const valores = new Set(radiosPerfil.map(r => r.valor))
      let listaRadios = radios.filter((radio) => valores.has(radio.valor))
      if (this.processo.tipo.codigo !== 'CERTIDAO_TITULO') {
        listaRadios = listaRadios.filter((radio) => radio.valor !== 'AGUARDANDO_ANALISE.PRESIDENTE.CPAD.ENCAMINHAMENTO.AUTOCOMPLETE')
      }
      return listaRadios
    },

    filterActionByRevisaoPortariaTitulo (radios) {
      return radios.filter((radio) => radio.valor !== 'RETORNO.SISTEMA.ANTERIOR')
    },

    async montarRadios (perfilLogado) {
      if (this.isModuloMoverProcesso) {
        this.radiosDespacho = this.radios
        this.radiosParecer = this.radios
        return
      }
      if (optionsRadios.includes(perfilLogado)) {
        this.radiosDespacho = this.filterActionByOptionRadio(this.radios, radiosDJ[perfilLogado].RADIOS_DESPACHO)
        this.radiosParecer = this.filterActionByOptionRadio(this.radios, radiosDJ[perfilLogado].RADIOS_PARECER)
        this.buscarUsuariosJuridico()
      } else {
        this.radiosDespacho = this.radios
        this.radiosParecer = this.radios
        if (process.env.ESTADO === 'ba' && this.processo?.setor === 'NAJ') {
          this.radiosParecer.map((a) => {
            if (a.nome.includes('PEG')) {
              a.nome = a.nome.replace('PEG', 'PGE')
            }
            if (a.nome === 'Encaminhar Setor' && perfilLogado.includes('ANALISTA')) {
              a.nome = a.nome.replace('Encaminhar Setor', 'Encaminhar Coordenador NAJ')
            }
          })
        }
      }
      if (this.portariaComNumero) {
        this.radiosDespacho = this.filterActionByRevisaoPortariaTitulo(this.radios)
      }
      if (this.isEsconderRetorno) {
        this.radiosDespacho = this.radiosDespacho.filter(r => !r.valor.includes('RETORNO') || r.valor.includes('AGUARDANDO_DISTRIBUICAO'))
        this.radiosParecer = this.radiosParecer.filter(r => !r.valor.includes('RETORNO') || r.valor.includes('AGUARDANDO_DISTRIBUICAO'))
      }
      if (this.isEsconderIndeferir) {
        this.radiosDespacho = this.radiosDespacho.filter(r => !r.valor.includes('AGUARDANDO_DISTRIBUICAO'))
        this.radiosParecer = this.radiosParecer.filter(r => !r.valor.includes('AGUARDANDO_DISTRIBUICAO'))
      }

      this.montarSelectUsuarios()
      this.radiosParecer = this.radiosParecer.filter(r => r.nome !== null)
      this.radiosDespacho = this.radiosDespacho.filter(radio => radio.nome !== null)
    }
  }
}
</script>
<style scoped lang="scss">

.flex {
  display: flex;
  justify-content: center;
}

.container-select {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.flex-buttons {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.margin-top {
  margin-top: 20px;
}

.margin {
  margin: 5px;
}

.container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

</style>



// WEBPACK FOOTER //
// src/components/AppRadiosTramitacao.vue